import React from 'react';
import PropTypes from 'prop-types';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { browserHistory } from 'react-router';
import { ContentCourseErrorRateListService } from '../../services/ContentListService';
import ContentErrorRateTable from '../commons/ContentErrorRateTable';
import { get } from 'lodash';
import { englishLevelCourses } from '../../../../../core/consts';

class ContentCourseErrorRateTableContainer extends React.Component {
  componentDidMount() {
    ContentCourseErrorRateListService.load(
      this.props.unitId ? 'unit' : this.props.moduleId ? 'module' : 'course',
      this.props.unitId || this.props.moduleId || this.props.courseId
    );
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.props.unitId !== prevProps.unitId ||
      this.props.moduleId !== prevProps.moduleId ||
      this.props.courseId !== prevProps.courseId
    ) {
      ContentCourseErrorRateListService.load(
        this.props.unitId ? 'unit' : this.props.moduleId ? 'module' : 'course',
        this.props.unitId || this.props.moduleId || this.props.courseId
      );
    }
  }

  render() {
    return (
      <ContentErrorRateTable
        loading={
          ContentCourseErrorRateListService.fetchCurrent.fetching ||
          ContentCourseErrorRateListService.fetchPrevious.fetching
        }
        values={toJS(ContentCourseErrorRateListService.getList()).map((item) =>
          Object.assign({}, item, {
            level: get(
              englishLevelCourses.find((c) => c.label === item.name),
              'value',
              null
            ),
          })
        )}
        nameColumnPath={this.props.courseId || this.props.moduleId || this.props.unitId ? 'order' : 'level'}
        nameColumnRender={(row) => {
          if (this.props.courseId || this.props.moduleId) {
            return `${row.group} - ${row.order} - ${row.name}`;
          } else {
            return row.name;
          }
        }}
        onSelect={(row) => {
          if (this.props.unitId) {
            return false;
          }
          if (this.props.moduleId) {
            browserHistory.push(
              `/kpis/content/course/${this.props.courseId}/module/${this.props.moduleId}/unit/${row.id}/details`
            );
          } else if (this.props.courseId) {
            browserHistory.push(`/kpis/content/course/${this.props.courseId}/module/${row.id}/details`);
          } else {
            browserHistory.push(`/kpis/content/course/${row.id}/details`);
          }
        }}
        formatter={ContentCourseErrorRateListService.getFormattedValue}
        feedbackColorRender={ContentCourseErrorRateListService.getFeedbackColor}
      />
    );
  }
}

ContentCourseErrorRateTableContainer.propTypes = {
  courseId: PropTypes.string,
  moduleId: PropTypes.string,
  unitId: PropTypes.string,
};

export default observer(ContentCourseErrorRateTableContainer);
